export default function toast() {
    /**
     *
     * Trigger a toast alert
     *
     */
    let _toastRunning = false
    window._toastAlert = function (content) {
        let toastEl = document.querySelector('.toast-alert')

        if (!toastEl) {
            return
        }

        toastEl.classList.remove('active')
        toastEl.innerHTML = content
        toastEl.classList.add('active')

        clearTimeout(_toastRunning)
        _toastRunning = setTimeout(function () {
            toastEl.classList.remove('active')
        }, 6000)
    }
    window._toastOnLoad = function () {
        if (sessionStorage.getItem('toastOnLoad')) {
            _toastAlert(sessionStorage.getItem('toastOnLoad'))
            sessionStorage.removeItem('toastOnLoad')
        }
    }
    _toastOnLoad()
}
